import { useSelector } from 'react-redux'
import type { State } from '../../Slice/index.js'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'

export const useGetSystemMessages = () => {
  return useSelector(selectSystemMessages)
}

const selectSystemMessages = (state: typeof State) => state[applicationSlice.name].systemMessages
